export default {
    'documentoEvidencias.PesoPdfInvalido': 'The pdf file exceeds the allowed weight of 15MB',
    'documentoEvidencias.BotonArchivo': 'Archive',
    'documentoEvidencias.alerta.limiteImagenes': 'You have exceeded the maximum number of images',
    'documentoEvidencias.alerta.archivoInvalido': 'The type of file entered is invalid',
    'documentoEvidencias.productoSinImagenes': 'No images uploaded',
};
